module.exports = __webpack_public_path__ + "assets/align-middle-blue.e072d65f.svg";